import { TReduxActions } from '../../../types/redux';
import { FILTERS_SET_REGION_ID_TYPE } from '../../../constants/action_types';
import { IJsonQuery, JsonQuery } from '../../../utils/jsonQuery';
import { defaultState } from './defaultState';

export function setRegionReducer(jsonQuery: IJsonQuery = defaultState, action: TReduxActions): IJsonQuery {
  switch (action.type) {
    case FILTERS_SET_REGION_ID_TYPE:
      return new JsonQuery(jsonQuery).setRegion(action.region).getSerializable();
  }

  return jsonQuery;
}
